import React from "react";
import { Button, notification } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import { bindActionCreators, compose } from "redux";
import { reduxForm } from "redux-form";
import * as SWMSMastersActions from "../../../../actions/SWMSMastersActions";
import footerLogo from "../service-farm-logo.png";
import { DownloadOutlined } from "@ant-design/icons";
import { Strings } from "../../../../dataProvider/localize";
import "./swmsPreviewPageContainer.css";
import jobStyles from "../../Job/JobStyle.module.css";

class SwmsPreviewJobSwms extends React.Component {
  state = {
    consequences: [],
    sites: [],
    selectedHazards: [],
    editorStateText: "",
    selectedCheckPpe: [],
    selectedCheckSwms: [],
    selectedCheckHRW: [],
    selectedCheckCHEM: [],
    selectedCheckLicensees: [],
    selectedCheckSpecific: [],
    swmsPdfLink: null,
    createdDetails: {},
    approverDetails: {},
    swmsNumber: '',
    swmsRevision: '',
    orgDetails: {},
    jobDetails: {},
    loadingSWMS: true,
    loadFailed: false
  };

  componentDidMount() {
    this.ApiCalls(this.props.jobId, this.props.quoteId, this.props.jobSwmsId);
  }

  downloadFile = (url) => {
    fetch(url).then((res) => {
      if (!res.ok) {
        notification.error({
          message: Strings.error_title,
          description: Strings.file_download_error,
          className: "ant-error",
        })
      } else {
        res.blob().then((blob) => {
          var file = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = file;
          let fileName = url.substring(url.lastIndexOf('/') + 1).toString();
          a.download = fileName;
          a.click();
          a.remove();
        })
      }
    }).catch(() => {
      notification.error({
        message: Strings.error_title,
        description: Strings.file_download_error,
        className: "ant-error",
      })
    });
  }

  ApiCalls = (jobId, quoteId, jobSwmsId) => {
    this.setState({ loadingSWMS: true, loadFailed: false })
    this.props.actions.getOrgDetailsPreview(jobId, quoteId, jobSwmsId).then((res) => {
      let ppeIds =
        res.ppes && res.ppes.length > 0 ? res.ppes.map((val) => val) : [];
      let swmsid =
        res.swms && res.swms.length > 0 ? res.swms.map((val) => val) : [];
      let hrwIds =
        res.high_risk_works && res.high_risk_works.length > 0
          ? res.high_risk_works.map((val) => val)
          : [];
      let chemicalIds =
        res.materials && res.materials.length > 0
          ? res.materials.map((val) => val)
          : [];
      let licenseIds =
        res.licenses && res.licenses.length > 0
          ? res.licenses.map((val) => val)
          : [];
      let sitespecificIds =
        res.site_specific_swms && res.site_specific_swms.length > 0
          ? res.site_specific_swms.map((val) => val)
          : [];
      let sites = res.sites && res.sites.length > 0 ? res.sites : [];
      let legislations =
        res.legislations && res.legislations.length > 0 ? res.legislations : [];
      let plant_and_equipments =
        res.plant_and_equipments && res.plant_and_equipments.length > 0
          ? res.plant_and_equipments
          : [];
      let document_details =
        res.document_details && res.document_details
          ? res.document_details
          : {};
      let training_and_qualifications =
        res.training_and_qualifications &&
          res.training_and_qualifications.length > 0
          ? res.training_and_qualifications
          : [];

      let monitor_and_reviews =
        res.monitor_and_reviews && res.monitor_and_reviews.length > 0
          ? res.monitor_and_reviews
          : [];
      let worker_duties =
        res.worker_duties && res.worker_duties.length > 0
          ? res.worker_duties
          : [];
      let job_swms_sign_offs =
        res.job_swms_sign_offs && res.job_swms_sign_offs.length > 0
          ? res.job_swms_sign_offs
          : [];


      let org_details = res.org_details && Object.keys(res.org_details).length > 0 ? res.org_details : {};
      let job_details = res.job_details && Object.keys(res.job_details).length > 0 ? res.job_details : {};

      let created_details = res.quote_created_by && res.quote_created_by.length > 0 ? res.quote_created_by[0] : {};
      let approver_details = res.quote_approver_details && res.quote_approver_details.length > 0 ? res.quote_approver_details[0] : {}
      let swms_number = res.swms_number ? res.swms_number : ''
      let swms_revision = res.swms_revision ? res.swms_revision : ''

      let swmsPdfLink = res.job_swms_pdf_link ? res.job_swms_pdf_link : null

      this.setState({
        ...this.state,
        sites: sites,
        selectedCheckPpe: ppeIds,
        selectedCheckSwms: swmsid,
        selectedCheckCHEM: chemicalIds,
        selectedCheckHRW: hrwIds,
        selectedCheckLicensees: licenseIds,
        selectedCheckSpecific: sitespecificIds,
        selectedLegislations: legislations,
        selectedPlant_and_equipments: plant_and_equipments,
        selectedDocument_details: document_details,
        selectedTraining_and_qualifications: training_and_qualifications,
        selectedWorker_duties: worker_duties,
        selectedMonitor_and_reviews: monitor_and_reviews,
        selectedJob_swms_sign_offs: job_swms_sign_offs,
        swmsPdfLink: swmsPdfLink,
        createdDetails: created_details,
        approverDetails: approver_details,
        swmsNumber: swms_number,
        swmsRevision: swms_revision,
        orgDetails: org_details,
        jobDetails: job_details,
        loadingSWMS: false,
      });
    }).catch(() => { this.setState({ loadFailed: true, loadingSWMS: false }) });;
  };

  render() {
    return (
      <React.Fragment>
        {this.state.loadingSWMS === false &&
          <>
            {this.state.loadFailed === false ?
              <>
                <div className="container-fluid  previewSwmsMain bg-white">
                  <div className="swms-preview-body">
                    <header className="container-fluid headbg pt-3">
                      <div className="row my-1 align-items-center">
                        <div className="col-sm-2 px-0">
                          <div className="preview-logo">
                            <img src={this.state.orgDetails && this.state.orgDetails.org_logo ? this.state.orgDetails.org_logo : ''} className="img-fluid" />
                          </div>
                        </div>
                        <div className="col-sm-10">
                          <p className="heading-jobSWMS text-right mb-0">Safe Work Method Statement (SWMS)</p>
                        </div>
                      </div>
                    </header>
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-6">
                          <div className="form-group flexlabel">
                            <label className="text-right">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={this.state.orgDetails && this.state.orgDetails.org_name ? this.state.orgDetails.org_name : ''}
                              name
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group flexlabel">
                            <label>Company ABN</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={this.state.orgDetails && this.state.orgDetails.abn_acn ? this.state.orgDetails.abn_acn : ''}
                              name
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group flexlabel">
                            <label>Company Phone</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={this.state.orgDetails && this.state.orgDetails.phone_number ? this.state.orgDetails.phone_number : ''}
                              name
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group flexlabel">
                            <label>Company Email</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={this.state.orgDetails && this.state.orgDetails.email_address ? this.state.orgDetails.email_address : ''}
                              name
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group flexlabel">
                            <label>Company Address</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={this.state.orgDetails && this.state.orgDetails.address ? this.state.orgDetails.address : ''}
                              name
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group flexlabel">
                            <label>Company Website</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={this.state.orgDetails && this.state.orgDetails.website ? this.state.orgDetails.website : ''}
                              name
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3 mb-0">
                        <div className="col-sm-12">
                          <div className="content-box">
                            <div className="form-group">
                              <label className="text-left">SWMS Conditions</label>
                              <textarea
                                className="form-control previewswms-textarea"
                                rows={2}
                                readOnly
                                defaultValue={
                                  "Work must be performed in accordance with this SWMS. This SWMS must be kept available for inspection until the high risk work to which the works relates is completed. If a notifiable incident occurs in relation to the high risk works  in this SWMS, the SWMS must be kept for at least 2 years from the date of the notifiable incident. "
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-6">
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group flexlabel">
                                <label>SWMS Initiated by:</label>
                                <input
                                  type="text"
                                  className="form-control lenght"
                                  defaultValue={this.state.createdDetails && this.state.createdDetails.name ? this.state.createdDetails.name : ''}
                                  maxLength={15}
                                  name
                                  readOnly
                                />
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group flexlabel">
                                <label className="role">Role:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue={this.state.createdDetails && this.state.createdDetails.role_name ? this.state.createdDetails.role_name : ''}
                                  name
                                  readOnly
                                />
                              </div>
                            </div>
                            <div className="col-sm-12">
                              <div className="form-group flexlabel">
                                <label>Manager Review:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue={this.state.approverDetails && this.state.approverDetails.quote_approver_name ?
                                    this.state.approverDetails.quote_approver_name : ''}
                                  name
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="row">
                            <div className="col-sm-4">
                              <div className="form-group flexlabel">
                                <label> Date SWMS Created:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue={this.state.createdDetails && this.state.createdDetails.created_at ?
                                    this.state.createdDetails.created_at : ''}
                                  name
                                  readOnly
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group flexlabel">
                                <label>SWMS Number:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue={this.state.swmsNumber ? this.state.swmsNumber : ''}
                                  name
                                  readOnly
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group flexlabel">
                                <label>SWMS Version :</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue={this.state.swmsRevision ? this.state.swmsRevision : ''}
                                  name
                                  readOnly
                                />
                              </div>
                            </div>
                            <div className="col-sm-7">
                              <div className="form-group flexlabel">
                                <label>Role:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue={this.state.approverDetails && this.state.approverDetails.quote_approver_role ?
                                    this.state.approverDetails.quote_approver_role : ''}
                                  name
                                  readOnly
                                />
                              </div>
                            </div>
                            <div className="col-sm-5">
                              <div className="form-group flexlabel">
                                <label>SWMS Review Date:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue={this.state.approverDetails && this.state.approverDetails.quote_review_at ?
                                    moment(this.state.approverDetails.quote_review_at).format("DD/MM/YYYY") : ''}
                                  name
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {this.state.sites &&
                        this.state.sites.length > 0 &&
                        this.state.sites.map((site) => {
                          return (
                            <div>
                              <div className="row">
                                <div className="col-sm-6">
                                  <div className="form-group flexlabel">
                                    <label>Site Name:</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      defaultValue={site.site_name}
                                      name
                                      readOnly
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <div className="form-group flexlabel">
                                    <label>Site Address:</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      defaultValue={site.site_address}
                                      name
                                      readOnly
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-8">
                                  <div className="form-group flexlabel">
                                    <label>Job/Project Name:</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      defaultValue={site.job_name}
                                      name
                                      readOnly
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-2">
                                  <div className="form-group flexlabel">
                                    <label>Work Start Date:</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      defaultValue={this.state.jobDetails && this.state.jobDetails.job_start_date ?
                                        moment(this.state.jobDetails.job_start_date).format("DD/MM/YYYY") : ''}
                                      name
                                      readOnly
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-2">
                                  <div className="form-group flexlabel">
                                    <label>Work End Date :</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      defaultValue={this.state.jobDetails && this.state.jobDetails.job_end_date ?
                                        moment(this.state.jobDetails.job_end_date).format("DD/MM/YYYY") : ''}
                                      name
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row mb-1 parent_append print-bottom">
                                {site.tasks &&
                                  site.tasks.map((task) => {
                                    return (
                                      <>
                                        <div className="col-sm-6">
                                          <div className="form-group flexlabel m-0">
                                            <label>Task Name:</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              defaultValue={task.task_name}
                                              name
                                              readOnly
                                            />
                                          </div>
                                        </div>
                                        <div className="col-sm-6">
                                          <div className="form-group flexlabel m-0">
                                            <label>Area:</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              defaultValue={task.area_name}
                                              name
                                              readOnly
                                            />
                                          </div>
                                        </div>
                                      </>
                                    );
                                  })}
                              </div>
                            </div>
                          );
                        })}

                      {this.state.selectedLegislations && this.state.selectedLegislations.length > 0 &&
                        <div className="row mb-0 mt-3">
                          <div className="col-sm-12">
                            <div className="content-box">
                              <div className="form-group">
                                <label className="half-width">
                                  Legislation / Codes of Practice / Standards Consulted
                                </label>
                                <div className="content-checkbox">
                                  <div className="row">
                                    <div className="col-sm-12 box-check box-50">
                                      <ul>
                                        {this.state.selectedLegislations &&
                                          this.state.selectedLegislations.length > 0 &&
                                          this.state.selectedLegislations.map((val) => {
                                            return (
                                              <li key={val.id}>
                                                <div className="form-check">
                                                  <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    defaultChecked
                                                    readOnly
                                                  />
                                                  <label className="form-check-label">
                                                    {val.title}
                                                  </label>
                                                </div>
                                              </li>
                                            );
                                          })}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      {this.state.selectedTraining_and_qualifications && this.state.selectedTraining_and_qualifications.length > 0 &&
                        <div className="row mb-0">
                          <div className="col-sm-12">
                            <div className="content-box">
                              <div className="form-group mt-1">
                                <label className="half-width">
                                  Training &amp; Licences
                                </label>

                                <div className="content-checkbox">
                                  <div className="row">
                                    <div className="col-sm-12 box-check">
                                      <ul>
                                        {this.state.selectedTraining_and_qualifications &&
                                          this.state.selectedTraining_and_qualifications
                                            .length > 0 &&
                                          this.state.selectedTraining_and_qualifications.map(
                                            (val) => {
                                              return (
                                                <li key={val.id}>
                                                  <div className="form-check">
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      defaultChecked
                                                      readOnly
                                                    />
                                                    <label className="form-check-label">
                                                      {val.name}
                                                    </label>
                                                  </div>
                                                </li>
                                              );
                                            }
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      {this.state.selectedPlant_and_equipments && this.state.selectedPlant_and_equipments.length > 0 &&
                        <div className="row mb-0 plant-equip">
                          <div className="col-sm-12">
                            <div className="content-box">
                              <div className="form-group ">
                                <label className="half-width">
                                  Plant and Equipment Required for Tasks
                                </label>
                                <div className="content-checkbox">
                                  <div className="row">
                                    <div className="col-sm-12 box-check">
                                      <ul>
                                        {this.state.selectedPlant_and_equipments &&
                                          this.state.selectedPlant_and_equipments.length >
                                          0 &&
                                          this.state.selectedPlant_and_equipments.map(
                                            (val) => {
                                              return (
                                                <li key={val.id}>
                                                  <div className="form-check">
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      defaultChecked
                                                      readOnly
                                                    />
                                                    <label className="form-check-label">
                                                      {val.name}
                                                    </label>
                                                  </div>
                                                </li>
                                              );
                                            }
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      {/* Only show if chemicals are available */}
                      {this.state.selectedCheckCHEM && this.state.selectedCheckCHEM.length > 0 &&
                        <div className="row mb-0">
                          <div className="col-sm-12">
                            <div className="content-box">
                              <div className="form-group">
                                <label className="half-width">
                                  Materials &amp; Chemicals Used
                                </label>
                                <div className="content-checkbox">
                                  <div className="row">
                                    <div className="col-sm-12 box-check">
                                      <ul>
                                        {this.state.selectedCheckCHEM &&
                                          this.state.selectedCheckCHEM.length > 0 &&
                                          this.state.selectedCheckCHEM.map((val) => {
                                            return (
                                              <li key={val.id}>
                                                <div className="form-check">
                                                  <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    defaultChecked
                                                    readOnly
                                                  />
                                                  <label className="form-check-label">
                                                    {val.name}
                                                  </label>
                                                </div>
                                              </li>
                                            );
                                          })}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      {this.state.selectedCheckHRW && this.state.selectedCheckHRW.length > 0 &&
                        <div className="row mb-0">
                          <div className="col-sm-12">
                            <div className="content-box">
                              <div className="form-group ">
                                <label className="half-width">High Risk Involves</label>

                                <div className="content-checkbox">
                                  <div className="row">
                                    <div className="col-sm-12 box-check">
                                      <ul>
                                        {this.state.selectedCheckHRW &&
                                          this.state.selectedCheckHRW.length > 0 &&
                                          this.state.selectedCheckHRW.map((val) => {
                                            return (
                                              <li key={val.id}>
                                                <div className="form-check">
                                                  <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    defaultChecked={val.selected === 1 ? true : false}
                                                    readOnly
                                                  />
                                                  <label className="form-check-label">
                                                    {val.name}
                                                  </label>
                                                </div>
                                              </li>
                                            );
                                          })}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      {this.state.selectedCheckPpe && this.state.selectedCheckPpe.length > 0 &&
                        <div className="row mb-0">
                          <div className="col-sm-12">
                            <div className="content-box">
                              <div className="form-group ">
                                <label className="half-width">
                                  Personal Protective Equipment(PPE)
                                </label>

                                <div className="content-checkbox">
                                  <div className="row">
                                    <div className="col-sm-12 box-check">
                                      <ul>
                                        {this.state.selectedCheckPpe &&
                                          this.state.selectedCheckPpe.length > 0 &&
                                          this.state.selectedCheckPpe.map((val) => {
                                            return (
                                              <li key={val.id}>
                                                <div className="form-check">
                                                  <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    defaultChecked={val.selected === 1 ? true : false}
                                                    readOnly
                                                  />
                                                  <label className="form-check-label">
                                                    {val.name}
                                                  </label>
                                                </div>
                                              </li>
                                            );
                                          })}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      {this.state.selectedWorker_duties && this.state.selectedWorker_duties.length > 0 &&
                        <div className="row mb-0">
                          <div className="col-sm-12">
                            <div className="content-box">
                              <div className="form-group">
                                <label className="half-width">
                                  Worker Duties &amp; Responsibility
                                </label>

                                <div className="content-checkbox">
                                  <div className="row">
                                    <div className="col-sm-12 box-check">
                                      <ul>
                                        {this.state.selectedWorker_duties &&
                                          this.state.selectedWorker_duties.length > 0 &&
                                          this.state.selectedWorker_duties.map((val) => {
                                            return (
                                              <li key={val.id}>
                                                <div className="form-check">
                                                  <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    defaultChecked
                                                    readOnly
                                                  />
                                                  <label className="form-check-label">
                                                    {val.name}
                                                  </label>
                                                </div>
                                              </li>
                                            );
                                          })}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      {this.state.selectedMonitor_and_reviews && this.state.selectedMonitor_and_reviews.length > 0 &&
                        <div className="row mb-0">
                          <div className="col-sm-12">
                            <div className="content-box">
                              <div className="form-group ">
                                <label className="half-width">Monitor &amp; Reviews</label>

                                <div className="content-checkbox">
                                  <div className="row">
                                    <div className="col-sm-12 box-check">
                                      <ul>
                                        {this.state.selectedMonitor_and_reviews &&
                                          this.state.selectedMonitor_and_reviews.length >
                                          0 &&
                                          this.state.selectedMonitor_and_reviews.map(
                                            (val) => {
                                              return (
                                                <li key={val.id}>
                                                  <div className="form-check">
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      defaultChecked
                                                      readOnly
                                                    />
                                                    <label className="form-check-label">
                                                      {val.name}
                                                    </label>
                                                  </div>
                                                </li>
                                              );
                                            }
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>

                    <div className="container-fluid py-4 mb-3">
                      <h2 className="h2_risk-matrix">RISK ASSESSMENT</h2>

                      <div className="row my-1">
                        <div className="col-sm-3 font-weight-bold">Step 1 – Determine the Likelihood (L)	</div>
                        <div className="col-sm-3 font-weight-bold">Step 2 – Determine the Consequence (C)</div>
                        <div className="col-sm-6 font-weight-bold">Step 3 – Asses the Risk Level (R) Determine the Risk Level by combining Likelihood and Consequence	</div>
                      </div>

                      <div className="table-responsive">
                        <table className="table_risk_matrix table-bordered">
                          <thead>
                            <tr>
                              <th rowspan="2" colspan="2" className="w30"> RISK MATRIX</th>
                              <th colspan="5">Consequence</th>
                            </tr>
                            <tr>
                              <th className="subbg">First aid, near miss, hazard identified, low environmental impact</th>
                              <th className="subbg">Medical treatment injury, return to work injuries, some environmental nuisance</th>
                              <th className="subbg">Lost time injury, partial impairment, on-site environmental harm substantial environment nuisance</th>
                              <th className="subbg">Permanent disability,single fatality, off-site environmental harm, on-site major contamination</th>
                              <th className="subbg">Multiple fatalities and/or likely environmental protection agency prosecution</th>
                            </tr>
                            <tr>
                              <th colspan="2"> Likelihood</th>
                              <th className="subbg">Insignificant (C1)</th>
                              <th className="subbg">Minor (C2)</th>
                              <th className="subbg">Moderate (C3)</th>
                              <th className="subbg">Major (C4)</th>
                              <th className="subbg">Critical (C5)</th>
                            </tr>
                          </thead>
                          <tr>
                            <td className="w20 subbg"> Expected to occur in most circumstances</td>
                            <td className="subbg"> Almost Certain <br />(L5)</td>
                            <td className="lr">LR<br /> 8 </td>
                            <td className="mr"> MR <br />14 </td>
                            <td className="hr">HR <br />19 </td>
                            <td className="er">ER <br />24  </td>
                            <td className="er">ER <br />25</td>
                          </tr>
                          <tr>
                            <td className="subbg">Probably occur in most circumstances</td>
                            <td className="subbg">Likely<br />(L4)</td>
                            <td className="lr">LR<br /> 7 </td>
                            <td className="mr"> MR <br />13 </td>
                            <td className="hr">HR <br />18 </td>
                            <td className="hr">HR <br />21  </td>
                            <td className="er">ER <br />23</td>
                          </tr>
                          <tr>
                            <td className="subbg">Should occur sometime (occurs 1 to 10 times a year)</td>
                            <td className="subbg">Possible<br />(L3)</td>
                            <td className="lr">LR<br /> 4 </td>
                            <td className="lr"> LR <br />9 </td>
                            <td className="mr">MR <br />15</td>
                            <td className="hr">HR <br />20 </td>
                            <td className="hr">HR <br />22</td>
                          </tr>
                          <tr>
                            <td className="subbg">Could occur at some time (occurs once every 2 to 10 yrs.)</td>
                            <td className="subbg">Unlikely<br />(L2)</td>
                            <td className="vl">VL<br /> 3</td>
                            <td className="lr"> LR <br />5</td>
                            <td className="lr">LR <br />10</td>
                            <td className="mr">MR <br />16</td>
                            <td className="mr">MR <br />17</td>
                          </tr>
                          <tr>
                            <td className="subbg">May occur only in exceptional circumstances (occurs once every 11 to 100 yrs.)</td>
                            <td className="subbg">Rare<br />(L1)</td>
                            <td className="vl">VL<br />1</td>
                            <td className="vl">VL<br />2</td>
                            <td className="lr">LR <br />6</td>
                            <td className="lr">LR <br />11</td>
                            <td className="lr">LR <br />12</td>
                          </tr>
                        </table>
                      </div>
                      <div>
                        <ul className="square my-2">
                          <li className="d-flex align-items-center"><span className="vlsquare"></span><b>(VL)    Very Low</b> - The risk should be managed as far as reasonably practicable, work may commence and no escalation necessary.</li>
                          <li className="d-flex align-items-center"><span className="lrsquare"></span><b>(LR)    Low Risk</b> - Acceptable region, should be managed routine procedures</li>
                          <li className="d-flex align-items-center"><span className="mrsquare"></span><b>(MR)    Moderate Risk </b>- Risk considerable enough for work not to commence without consideration and use of control measures (such as preparing SWMS)</li>
                          <li className="d-flex align-items-center"><span className="hrsquare"></span><b>(HR)    High Risk </b>- Risk is unacceptable, work must not commence, risk must be treated, if reasonably practicable further consideration given to whether additional control measures are required </li>
                          <li className="d-flex align-items-center"><span className="ersquare"></span><b>(ER)    Extreme Risk</b> - Unacceptable level of risk, controls must be immediately implemented
                            to reduce risk eliminated (ie. cease activity)</li>
                        </ul>
                      </div>

                      <div>
                        <h2 className="h2_risk-matrix my-1">HIERARCHY OF CONTROLS</h2>
                        <div className="footer_block px-3">
                          <div className="d-flex justify-content-center align-items-center">
                            <div>
                              <p className="font-weight-bold m-0 mx-3">Highest Level of Control</p>
                            </div>
                            <div>
                              <svg width="650" height="51" viewBox="0 0 802 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M650 1H762.702L800.173 25.5L762.702 50H650V1Z" fill="#F03202" stroke="#E5F6F4" stroke-width="2" />
                                <path d="M498 1H653.702L691.173 25.5L653.702 50H498V1Z" fill="#F89644" stroke="#E5F6F4" stroke-width="2" />
                                <path d="M348 1H496.702L534.173 25.5L496.702 50H348V1Z" fill="#FED803" stroke="#E5F6F4" stroke-width="2" />
                                <path d="M222 1H360.702L398.173 25.5L360.702 50H222V1Z" fill="#08C679" stroke="#E5F6F4" stroke-width="2" />
                                <path d="M92 1H228.702L266.173 25.5L228.702 50H92V1Z" fill="#01975B" stroke="#E5F6F4" stroke-width="2" />
                                <path d="M1 1H93.7021L131.173 25.5L93.7021 50H1V1Z" fill="#0258FE" stroke="#E5F6F4" stroke-width="2" />
                                <path d="M18.1074 30V19.9785H25.3535V21.1611H19.4336V24.2305H24.9775V25.4062H19.4336V28.8174H25.5859V30H18.1074ZM27.2334 30V19.9785H28.4639V30H27.2334ZM30.3848 21.3936V19.9785H31.6152V21.3936H30.3848ZM30.3848 30V22.7402H31.6152V30H30.3848ZM33.4951 30V22.7402H34.5957V23.7588C34.8236 23.4033 35.1266 23.1185 35.5049 22.9043C35.8831 22.6855 36.3138 22.5762 36.7969 22.5762C37.3346 22.5762 37.7744 22.6878 38.1162 22.9111C38.4626 23.1344 38.7064 23.4466 38.8477 23.8477C39.4219 23 40.1693 22.5762 41.0898 22.5762C41.8099 22.5762 42.3636 22.7767 42.751 23.1777C43.1383 23.5742 43.332 24.1872 43.332 25.0166V30H42.1084V25.4268C42.1084 24.9346 42.0674 24.5814 41.9854 24.3672C41.9079 24.1484 41.7643 23.973 41.5547 23.8408C41.3451 23.7087 41.099 23.6426 40.8164 23.6426C40.306 23.6426 39.8822 23.8135 39.5449 24.1553C39.2077 24.4925 39.0391 25.0348 39.0391 25.7822V30H37.8086V25.2832C37.8086 24.7363 37.7083 24.3262 37.5078 24.0527C37.3073 23.7793 36.9792 23.6426 36.5234 23.6426C36.1771 23.6426 35.8558 23.7337 35.5596 23.916C35.2679 24.0983 35.056 24.3649 34.9238 24.7158C34.7917 25.0667 34.7256 25.5726 34.7256 26.2334V30H33.4951ZM45.1641 21.3936V19.9785H46.3945V21.3936H45.1641ZM45.1641 30V22.7402H46.3945V30H45.1641ZM48.2744 30V22.7402H49.3818V23.7725C49.915 22.9749 50.6852 22.5762 51.6924 22.5762C52.1299 22.5762 52.5309 22.6559 52.8955 22.8154C53.2646 22.9704 53.5404 23.1755 53.7227 23.4307C53.9049 23.6859 54.0326 23.9889 54.1055 24.3398C54.151 24.5677 54.1738 24.9665 54.1738 25.5361V30H52.9434V25.584C52.9434 25.0827 52.8955 24.709 52.7998 24.4629C52.7041 24.2122 52.5332 24.014 52.2871 23.8682C52.0456 23.7178 51.7607 23.6426 51.4326 23.6426C50.9085 23.6426 50.4551 23.8089 50.0723 24.1416C49.694 24.4743 49.5049 25.1055 49.5049 26.0352V30H48.2744ZM60.8047 29.1045C60.349 29.4919 59.9092 29.7653 59.4854 29.9248C59.0661 30.0843 58.6149 30.1641 58.1318 30.1641C57.3343 30.1641 56.7214 29.9704 56.293 29.583C55.8646 29.1911 55.6504 28.6921 55.6504 28.0859C55.6504 27.7305 55.7301 27.4069 55.8896 27.1152C56.0537 26.819 56.2656 26.582 56.5254 26.4043C56.7897 26.2266 57.0859 26.0921 57.4141 26.001C57.6556 25.9372 58.0202 25.8757 58.5078 25.8164C59.5013 25.6979 60.2327 25.5566 60.7021 25.3926C60.7067 25.224 60.709 25.1169 60.709 25.0713C60.709 24.57 60.5928 24.2168 60.3604 24.0117C60.0459 23.7337 59.5788 23.5947 58.959 23.5947C58.3802 23.5947 57.9518 23.6973 57.6738 23.9023C57.4004 24.1029 57.1976 24.4606 57.0654 24.9756L55.8623 24.8115C55.9717 24.2965 56.1517 23.8818 56.4023 23.5674C56.653 23.2484 57.0153 23.0046 57.4893 22.8359C57.9632 22.6628 58.5124 22.5762 59.1367 22.5762C59.7565 22.5762 60.2601 22.6491 60.6475 22.7949C61.0348 22.9408 61.3197 23.1253 61.502 23.3486C61.6842 23.5674 61.8118 23.8454 61.8848 24.1826C61.9258 24.3923 61.9463 24.7705 61.9463 25.3174V26.958C61.9463 28.1019 61.9714 28.8265 62.0215 29.1318C62.0762 29.4326 62.181 29.722 62.3359 30H61.0508C60.9232 29.7448 60.8411 29.4463 60.8047 29.1045ZM60.7021 26.3564C60.2555 26.5387 59.5856 26.6937 58.6924 26.8213C58.1865 26.8942 57.8288 26.9762 57.6191 27.0674C57.4095 27.1585 57.2477 27.293 57.1338 27.4707C57.0199 27.6439 56.9629 27.8376 56.9629 28.0518C56.9629 28.3799 57.0859 28.6533 57.332 28.8721C57.5827 29.0908 57.9473 29.2002 58.4258 29.2002C58.8997 29.2002 59.3213 29.0977 59.6904 28.8926C60.0596 28.6829 60.3307 28.3981 60.5039 28.0381C60.6361 27.7601 60.7021 27.3499 60.7021 26.8076V26.3564ZM66.5469 28.8994L66.7246 29.9863C66.3783 30.0592 66.0684 30.0957 65.7949 30.0957C65.3483 30.0957 65.002 30.0251 64.7559 29.8838C64.5098 29.7425 64.3366 29.5579 64.2363 29.3301C64.1361 29.0977 64.0859 28.6123 64.0859 27.874V23.6973H63.1836V22.7402H64.0859V20.9424L65.3096 20.2041V22.7402H66.5469V23.6973H65.3096V27.9424C65.3096 28.2933 65.3301 28.5189 65.3711 28.6191C65.4167 28.7194 65.4873 28.7992 65.583 28.8584C65.6833 28.9176 65.8245 28.9473 66.0068 28.9473C66.1436 28.9473 66.3236 28.9313 66.5469 28.8994ZM67.7637 21.3936V19.9785H68.9941V21.3936H67.7637ZM67.7637 30V22.7402H68.9941V30H67.7637ZM70.416 26.3701C70.416 25.0257 70.7897 24.0299 71.5371 23.3828C72.1615 22.8451 72.9225 22.5762 73.8203 22.5762C74.8184 22.5762 75.6341 22.9043 76.2676 23.5605C76.901 24.2122 77.2178 25.1146 77.2178 26.2676C77.2178 27.2018 77.0765 27.9378 76.7939 28.4756C76.516 29.0088 76.1081 29.4235 75.5703 29.7197C75.0371 30.016 74.4538 30.1641 73.8203 30.1641C72.804 30.1641 71.9814 29.8382 71.3525 29.1865C70.7282 28.5348 70.416 27.596 70.416 26.3701ZM71.6807 26.3701C71.6807 27.2998 71.8835 27.9971 72.2891 28.4619C72.6947 28.9222 73.2051 29.1523 73.8203 29.1523C74.431 29.1523 74.9391 28.9199 75.3447 28.4551C75.7503 27.9902 75.9531 27.2816 75.9531 26.3291C75.9531 25.4313 75.748 24.7523 75.3379 24.292C74.9323 23.8271 74.4264 23.5947 73.8203 23.5947C73.2051 23.5947 72.6947 23.8249 72.2891 24.2852C71.8835 24.7454 71.6807 25.4404 71.6807 26.3701ZM78.667 30V22.7402H79.7744V23.7725C80.3076 22.9749 81.0778 22.5762 82.085 22.5762C82.5225 22.5762 82.9235 22.6559 83.2881 22.8154C83.6572 22.9704 83.9329 23.1755 84.1152 23.4307C84.2975 23.6859 84.4251 23.9889 84.498 24.3398C84.5436 24.5677 84.5664 24.9665 84.5664 25.5361V30H83.3359V25.584C83.3359 25.0827 83.2881 24.709 83.1924 24.4629C83.0967 24.2122 82.9258 24.014 82.6797 23.8682C82.4382 23.7178 82.1533 23.6426 81.8252 23.6426C81.3011 23.6426 80.8477 23.8089 80.4648 24.1416C80.0866 24.4743 79.8975 25.1055 79.8975 26.0352V30H78.667Z" fill="white" />
                                <path d="M144.629 24.7803L145.88 24.6709C145.939 25.1722 146.076 25.5846 146.29 25.9082C146.509 26.2272 146.846 26.487 147.302 26.6875C147.757 26.8835 148.27 26.9814 148.84 26.9814C149.346 26.9814 149.792 26.9062 150.18 26.7559C150.567 26.6055 150.854 26.4004 151.041 26.1406C151.232 25.8763 151.328 25.5892 151.328 25.2793C151.328 24.9648 151.237 24.6914 151.055 24.459C150.872 24.222 150.572 24.0238 150.152 23.8643C149.883 23.7594 149.289 23.5977 148.368 23.3789C147.448 23.1556 146.803 22.946 146.434 22.75C145.955 22.4993 145.597 22.1895 145.36 21.8203C145.128 21.4466 145.012 21.0296 145.012 20.5693C145.012 20.0635 145.155 19.5918 145.442 19.1543C145.729 18.7122 146.149 18.3773 146.7 18.1494C147.252 17.9215 147.865 17.8076 148.539 17.8076C149.282 17.8076 149.936 17.9284 150.501 18.1699C151.071 18.4069 151.508 18.7578 151.813 19.2227C152.119 19.6875 152.283 20.2139 152.306 20.8018L151.034 20.8975C150.966 20.264 150.733 19.7855 150.337 19.4619C149.945 19.1383 149.364 18.9766 148.594 18.9766C147.792 18.9766 147.206 19.1247 146.837 19.4209C146.472 19.7126 146.29 20.0658 146.29 20.4805C146.29 20.8405 146.42 21.1367 146.68 21.3691C146.935 21.6016 147.6 21.8408 148.676 22.0869C149.756 22.3285 150.496 22.5404 150.897 22.7227C151.481 22.9915 151.911 23.3333 152.189 23.748C152.467 24.1582 152.606 24.6322 152.606 25.1699C152.606 25.7031 152.454 26.2067 152.148 26.6807C151.843 27.1501 151.403 27.5169 150.829 27.7812C150.259 28.041 149.617 28.1709 148.901 28.1709C147.994 28.1709 147.233 28.0387 146.618 27.7744C146.007 27.5101 145.527 27.1136 145.176 26.585C144.829 26.0518 144.647 25.4502 144.629 24.7803ZM159.019 28V26.9336C158.453 27.7539 157.686 28.1641 156.715 28.1641C156.286 28.1641 155.885 28.082 155.512 27.918C155.143 27.7539 154.867 27.5488 154.685 27.3027C154.507 27.0521 154.382 26.7467 154.309 26.3867C154.258 26.1452 154.233 25.7624 154.233 25.2383V20.7402H155.464V24.7666C155.464 25.4092 155.489 25.8421 155.539 26.0654C155.617 26.389 155.781 26.6442 156.031 26.8311C156.282 27.0133 156.592 27.1045 156.961 27.1045C157.33 27.1045 157.676 27.0111 158 26.8242C158.324 26.6328 158.551 26.3753 158.684 26.0518C158.82 25.7236 158.889 25.2497 158.889 24.6299V20.7402H160.119V28H159.019ZM163.188 28H162.047V17.9785H163.277V21.5537C163.797 20.902 164.46 20.5762 165.267 20.5762C165.713 20.5762 166.135 20.6673 166.531 20.8496C166.932 21.0273 167.26 21.2803 167.516 21.6084C167.775 21.932 167.978 22.3239 168.124 22.7842C168.27 23.2445 168.343 23.7367 168.343 24.2607C168.343 25.5049 168.035 26.4665 167.42 27.1455C166.805 27.8245 166.066 28.1641 165.205 28.1641C164.348 28.1641 163.676 27.8063 163.188 27.0908V28ZM163.175 24.3154C163.175 25.1859 163.293 25.8148 163.53 26.2021C163.918 26.8356 164.442 27.1523 165.103 27.1523C165.64 27.1523 166.105 26.9199 166.497 26.4551C166.889 25.9857 167.085 25.2884 167.085 24.3633C167.085 23.4154 166.896 22.7158 166.518 22.2646C166.144 21.8135 165.69 21.5879 165.157 21.5879C164.619 21.5879 164.155 21.8226 163.763 22.292C163.371 22.7568 163.175 23.4313 163.175 24.3154ZM169.354 25.833L170.571 25.6416C170.64 26.1292 170.829 26.5029 171.139 26.7627C171.453 27.0225 171.891 27.1523 172.451 27.1523C173.016 27.1523 173.436 27.0384 173.709 26.8105C173.982 26.5781 174.119 26.307 174.119 25.9971C174.119 25.7191 173.998 25.5003 173.757 25.3408C173.588 25.2314 173.169 25.0924 172.499 24.9238C171.597 24.696 170.97 24.5 170.619 24.3359C170.273 24.1673 170.008 23.9372 169.826 23.6455C169.648 23.3493 169.56 23.0234 169.56 22.668C169.56 22.3444 169.632 22.0459 169.778 21.7725C169.929 21.4945 170.132 21.2643 170.387 21.082C170.578 20.9408 170.838 20.8223 171.166 20.7266C171.499 20.6263 171.854 20.5762 172.232 20.5762C172.802 20.5762 173.301 20.6582 173.729 20.8223C174.162 20.9863 174.481 21.2096 174.687 21.4922C174.892 21.7702 175.033 22.1439 175.11 22.6133L173.907 22.7773C173.853 22.4036 173.693 22.112 173.429 21.9023C173.169 21.6927 172.8 21.5879 172.321 21.5879C171.756 21.5879 171.353 21.6813 171.111 21.8682C170.87 22.055 170.749 22.2738 170.749 22.5244C170.749 22.6839 170.799 22.8275 170.899 22.9551C171 23.0872 171.157 23.1966 171.371 23.2832C171.494 23.3288 171.856 23.4336 172.458 23.5977C173.328 23.8301 173.935 24.0215 174.276 24.1719C174.623 24.3177 174.894 24.5319 175.09 24.8145C175.286 25.097 175.384 25.4479 175.384 25.8672C175.384 26.2773 175.263 26.6647 175.021 27.0293C174.785 27.3893 174.44 27.6696 173.989 27.8701C173.538 28.0661 173.028 28.1641 172.458 28.1641C171.515 28.1641 170.795 27.9681 170.298 27.5762C169.806 27.1842 169.491 26.6032 169.354 25.833ZM179.533 26.8994L179.711 27.9863C179.365 28.0592 179.055 28.0957 178.781 28.0957C178.335 28.0957 177.988 28.0251 177.742 27.8838C177.496 27.7425 177.323 27.5579 177.223 27.3301C177.122 27.0977 177.072 26.6123 177.072 25.874V21.6973H176.17V20.7402H177.072V18.9424L178.296 18.2041V20.7402H179.533V21.6973H178.296V25.9424C178.296 26.2933 178.316 26.5189 178.357 26.6191C178.403 26.7194 178.474 26.7992 178.569 26.8584C178.67 26.9176 178.811 26.9473 178.993 26.9473C179.13 26.9473 179.31 26.9313 179.533 26.8994ZM180.75 19.3936V17.9785H181.98V19.3936H180.75ZM180.75 28V20.7402H181.98V28H180.75ZM186.547 26.8994L186.725 27.9863C186.378 28.0592 186.068 28.0957 185.795 28.0957C185.348 28.0957 185.002 28.0251 184.756 27.8838C184.51 27.7425 184.337 27.5579 184.236 27.3301C184.136 27.0977 184.086 26.6123 184.086 25.874V21.6973H183.184V20.7402H184.086V18.9424L185.31 18.2041V20.7402H186.547V21.6973H185.31V25.9424C185.31 26.2933 185.33 26.5189 185.371 26.6191C185.417 26.7194 185.487 26.7992 185.583 26.8584C185.683 26.9176 185.825 26.9473 186.007 26.9473C186.144 26.9473 186.324 26.9313 186.547 26.8994ZM192.515 28V26.9336C191.95 27.7539 191.182 28.1641 190.211 28.1641C189.783 28.1641 189.382 28.082 189.008 27.918C188.639 27.7539 188.363 27.5488 188.181 27.3027C188.003 27.0521 187.878 26.7467 187.805 26.3867C187.755 26.1452 187.729 25.7624 187.729 25.2383V20.7402H188.96V24.7666C188.96 25.4092 188.985 25.8421 189.035 26.0654C189.113 26.389 189.277 26.6442 189.527 26.8311C189.778 27.0133 190.088 27.1045 190.457 27.1045C190.826 27.1045 191.173 27.0111 191.496 26.8242C191.82 26.6328 192.048 26.3753 192.18 26.0518C192.316 25.7236 192.385 25.2497 192.385 24.6299V20.7402H193.615V28H192.515ZM198.236 26.8994L198.414 27.9863C198.068 28.0592 197.758 28.0957 197.484 28.0957C197.038 28.0957 196.691 28.0251 196.445 27.8838C196.199 27.7425 196.026 27.5579 195.926 27.3301C195.826 27.0977 195.775 26.6123 195.775 25.874V21.6973H194.873V20.7402H195.775V18.9424L196.999 18.2041V20.7402H198.236V21.6973H196.999V25.9424C196.999 26.2933 197.02 26.5189 197.061 26.6191C197.106 26.7194 197.177 26.7992 197.272 26.8584C197.373 26.9176 197.514 26.9473 197.696 26.9473C197.833 26.9473 198.013 26.9313 198.236 26.8994ZM199.453 19.3936V17.9785H200.684V19.3936H199.453ZM199.453 28V20.7402H200.684V28H199.453ZM202.105 24.3701C202.105 23.0257 202.479 22.0299 203.227 21.3828C203.851 20.8451 204.612 20.5762 205.51 20.5762C206.508 20.5762 207.324 20.9043 207.957 21.5605C208.59 22.2122 208.907 23.1146 208.907 24.2676C208.907 25.2018 208.766 25.9378 208.483 26.4756C208.205 27.0088 207.798 27.4235 207.26 27.7197C206.727 28.016 206.143 28.1641 205.51 28.1641C204.493 28.1641 203.671 27.8382 203.042 27.1865C202.418 26.5348 202.105 25.596 202.105 24.3701ZM203.37 24.3701C203.37 25.2998 203.573 25.9971 203.979 26.4619C204.384 26.9222 204.895 27.1523 205.51 27.1523C206.12 27.1523 206.629 26.9199 207.034 26.4551C207.44 25.9902 207.643 25.2816 207.643 24.3291C207.643 23.4313 207.438 22.7523 207.027 22.292C206.622 21.8271 206.116 21.5947 205.51 21.5947C204.895 21.5947 204.384 21.8249 203.979 22.2852C203.573 22.7454 203.37 23.4404 203.37 24.3701ZM210.356 28V20.7402H211.464V21.7725C211.997 20.9749 212.767 20.5762 213.774 20.5762C214.212 20.5762 214.613 20.6559 214.978 20.8154C215.347 20.9704 215.622 21.1755 215.805 21.4307C215.987 21.6859 216.115 21.9889 216.188 22.3398C216.233 22.5677 216.256 22.9665 216.256 23.5361V28H215.025V23.584C215.025 23.0827 214.978 22.709 214.882 22.4629C214.786 22.2122 214.615 22.014 214.369 21.8682C214.128 21.7178 213.843 21.6426 213.515 21.6426C212.991 21.6426 212.537 21.8089 212.154 22.1416C211.776 22.4743 211.587 23.1055 211.587 24.0352V28H210.356Z" fill="white" />
                                <path d="M288.306 28V17.9785H289.632V28H288.306ZM291.327 25.833L292.544 25.6416C292.612 26.1292 292.801 26.5029 293.111 26.7627C293.426 27.0225 293.863 27.1523 294.424 27.1523C294.989 27.1523 295.408 27.0384 295.682 26.8105C295.955 26.5781 296.092 26.307 296.092 25.9971C296.092 25.7191 295.971 25.5003 295.729 25.3408C295.561 25.2314 295.142 25.0924 294.472 24.9238C293.569 24.696 292.943 24.5 292.592 24.3359C292.245 24.1673 291.981 23.9372 291.799 23.6455C291.621 23.3493 291.532 23.0234 291.532 22.668C291.532 22.3444 291.605 22.0459 291.751 21.7725C291.901 21.4945 292.104 21.2643 292.359 21.082C292.551 20.9408 292.811 20.8223 293.139 20.7266C293.471 20.6263 293.827 20.5762 294.205 20.5762C294.775 20.5762 295.274 20.6582 295.702 20.8223C296.135 20.9863 296.454 21.2096 296.659 21.4922C296.864 21.7702 297.006 22.1439 297.083 22.6133L295.88 22.7773C295.825 22.4036 295.666 22.112 295.401 21.9023C295.142 21.6927 294.772 21.5879 294.294 21.5879C293.729 21.5879 293.326 21.6813 293.084 21.8682C292.842 22.055 292.722 22.2738 292.722 22.5244C292.722 22.6839 292.772 22.8275 292.872 22.9551C292.972 23.0872 293.13 23.1966 293.344 23.2832C293.467 23.3288 293.829 23.4336 294.431 23.5977C295.301 23.8301 295.907 24.0215 296.249 24.1719C296.595 24.3177 296.867 24.5319 297.062 24.8145C297.258 25.097 297.356 25.4479 297.356 25.8672C297.356 26.2773 297.236 26.6647 296.994 27.0293C296.757 27.3893 296.413 27.6696 295.962 27.8701C295.511 28.0661 295 28.1641 294.431 28.1641C293.487 28.1641 292.767 27.9681 292.271 27.5762C291.778 27.1842 291.464 26.6032 291.327 25.833ZM298.361 24.3701C298.361 23.0257 298.735 22.0299 299.482 21.3828C300.107 20.8451 300.868 20.5762 301.766 20.5762C302.764 20.5762 303.579 20.9043 304.213 21.5605C304.846 22.2122 305.163 23.1146 305.163 24.2676C305.163 25.2018 305.022 25.9378 304.739 26.4756C304.461 27.0088 304.053 27.4235 303.516 27.7197C302.982 28.016 302.399 28.1641 301.766 28.1641C300.749 28.1641 299.927 27.8382 299.298 27.1865C298.674 26.5348 298.361 25.596 298.361 24.3701ZM299.626 24.3701C299.626 25.2998 299.829 25.9971 300.234 26.4619C300.64 26.9222 301.15 27.1523 301.766 27.1523C302.376 27.1523 302.884 26.9199 303.29 26.4551C303.696 25.9902 303.898 25.2816 303.898 24.3291C303.898 23.4313 303.693 22.7523 303.283 22.292C302.878 21.8271 302.372 21.5947 301.766 21.5947C301.15 21.5947 300.64 21.8249 300.234 22.2852C299.829 22.7454 299.626 23.4404 299.626 24.3701ZM306.585 28V17.9785H307.815V28H306.585ZM314.467 27.1045C314.011 27.4919 313.571 27.7653 313.147 27.9248C312.728 28.0843 312.277 28.1641 311.794 28.1641C310.996 28.1641 310.383 27.9704 309.955 27.583C309.527 27.1911 309.312 26.6921 309.312 26.0859C309.312 25.7305 309.392 25.4069 309.552 25.1152C309.716 24.819 309.928 24.582 310.188 24.4043C310.452 24.2266 310.748 24.0921 311.076 24.001C311.318 23.9372 311.682 23.8757 312.17 23.8164C313.163 23.6979 313.895 23.5566 314.364 23.3926C314.369 23.224 314.371 23.1169 314.371 23.0713C314.371 22.57 314.255 22.2168 314.022 22.0117C313.708 21.7337 313.241 21.5947 312.621 21.5947C312.042 21.5947 311.614 21.6973 311.336 21.9023C311.062 22.1029 310.86 22.4606 310.728 22.9756L309.524 22.8115C309.634 22.2965 309.814 21.8818 310.064 21.5674C310.315 21.2484 310.677 21.0046 311.151 20.8359C311.625 20.6628 312.174 20.5762 312.799 20.5762C313.419 20.5762 313.922 20.6491 314.31 20.7949C314.697 20.9408 314.982 21.1253 315.164 21.3486C315.346 21.5674 315.474 21.8454 315.547 22.1826C315.588 22.3923 315.608 22.7705 315.608 23.3174V24.958C315.608 26.1019 315.633 26.8265 315.684 27.1318C315.738 27.4326 315.843 27.722 315.998 28H314.713C314.585 27.7448 314.503 27.4463 314.467 27.1045ZM314.364 24.3564C313.918 24.5387 313.248 24.6937 312.354 24.8213C311.849 24.8942 311.491 24.9762 311.281 25.0674C311.072 25.1585 310.91 25.293 310.796 25.4707C310.682 25.6439 310.625 25.8376 310.625 26.0518C310.625 26.3799 310.748 26.6533 310.994 26.8721C311.245 27.0908 311.609 27.2002 312.088 27.2002C312.562 27.2002 312.983 27.0977 313.353 26.8926C313.722 26.6829 313.993 26.3981 314.166 26.0381C314.298 25.7601 314.364 25.3499 314.364 24.8076V24.3564ZM320.209 26.8994L320.387 27.9863C320.04 28.0592 319.73 28.0957 319.457 28.0957C319.01 28.0957 318.664 28.0251 318.418 27.8838C318.172 27.7425 317.999 27.5579 317.898 27.3301C317.798 27.0977 317.748 26.6123 317.748 25.874V21.6973H316.846V20.7402H317.748V18.9424L318.972 18.2041V20.7402H320.209V21.6973H318.972V25.9424C318.972 26.2933 318.992 26.5189 319.033 26.6191C319.079 26.7194 319.149 26.7992 319.245 26.8584C319.345 26.9176 319.487 26.9473 319.669 26.9473C319.806 26.9473 319.986 26.9313 320.209 26.8994ZM321.426 19.3936V17.9785H322.656V19.3936H321.426ZM321.426 28V20.7402H322.656V28H321.426ZM324.078 24.3701C324.078 23.0257 324.452 22.0299 325.199 21.3828C325.824 20.8451 326.585 20.5762 327.482 20.5762C328.48 20.5762 329.296 20.9043 329.93 21.5605C330.563 22.2122 330.88 23.1146 330.88 24.2676C330.88 25.2018 330.739 25.9378 330.456 26.4756C330.178 27.0088 329.77 27.4235 329.232 27.7197C328.699 28.016 328.116 28.1641 327.482 28.1641C326.466 28.1641 325.644 27.8382 325.015 27.1865C324.39 26.5348 324.078 25.596 324.078 24.3701ZM325.343 24.3701C325.343 25.2998 325.546 25.9971 325.951 26.4619C326.357 26.9222 326.867 27.1523 327.482 27.1523C328.093 27.1523 328.601 26.9199 329.007 26.4551C329.412 25.9902 329.615 25.2816 329.615 24.3291C329.615 23.4313 329.41 22.7523 329 22.292C328.594 21.8271 328.089 21.5947 327.482 21.5947C326.867 21.5947 326.357 21.8249 325.951 22.2852C325.546 22.7454 325.343 23.4404 325.343 24.3701ZM332.329 28V20.7402H333.437V21.7725C333.97 20.9749 334.74 20.5762 335.747 20.5762C336.185 20.5762 336.586 20.6559 336.95 20.8154C337.319 20.9704 337.595 21.1755 337.777 21.4307C337.96 21.6859 338.087 21.9889 338.16 22.3398C338.206 22.5677 338.229 22.9665 338.229 23.5361V28H336.998V23.584C336.998 23.0827 336.95 22.709 336.854 22.4629C336.759 22.2122 336.588 22.014 336.342 21.8682C336.1 21.7178 335.815 21.6426 335.487 21.6426C334.963 21.6426 334.51 21.8089 334.127 22.1416C333.749 22.4743 333.56 23.1055 333.56 24.0352V28H332.329Z" fill="black" />
                                <path d="M416.107 28V17.9785H423.354V19.1611H417.434V22.2305H422.978V23.4062H417.434V26.8174H423.586V28H416.107ZM425.261 28V20.7402H426.368V21.7725C426.901 20.9749 427.672 20.5762 428.679 20.5762C429.116 20.5762 429.517 20.6559 429.882 20.8154C430.251 20.9704 430.527 21.1755 430.709 21.4307C430.891 21.6859 431.019 21.9889 431.092 22.3398C431.137 22.5677 431.16 22.9665 431.16 23.5361V28H429.93V23.584C429.93 23.0827 429.882 22.709 429.786 22.4629C429.69 22.2122 429.52 22.014 429.273 21.8682C429.032 21.7178 428.747 21.6426 428.419 21.6426C427.895 21.6426 427.441 21.8089 427.059 22.1416C426.68 22.4743 426.491 23.1055 426.491 24.0352V28H425.261ZM432.828 28.6016L434.024 28.7793C434.075 29.1484 434.214 29.4173 434.441 29.5859C434.747 29.8138 435.164 29.9277 435.692 29.9277C436.262 29.9277 436.702 29.8138 437.012 29.5859C437.322 29.3581 437.531 29.0391 437.641 28.6289C437.704 28.3783 437.734 27.8519 437.729 27.0498C437.192 27.6833 436.522 28 435.72 28C434.722 28 433.949 27.64 433.402 26.9199C432.855 26.1999 432.582 25.3363 432.582 24.3291C432.582 23.6364 432.707 22.9984 432.958 22.415C433.209 21.8271 433.571 21.3737 434.045 21.0547C434.523 20.7357 435.084 20.5762 435.727 20.5762C436.583 20.5762 437.29 20.9225 437.846 21.6152V20.7402H438.98V27.0156C438.98 28.1458 438.864 28.9456 438.632 29.415C438.404 29.889 438.039 30.2627 437.538 30.5361C437.041 30.8096 436.428 30.9463 435.699 30.9463C434.833 30.9463 434.134 30.7503 433.601 30.3584C433.067 29.971 432.81 29.3854 432.828 28.6016ZM433.847 24.2402C433.847 25.1927 434.036 25.8877 434.414 26.3252C434.792 26.7627 435.266 26.9814 435.836 26.9814C436.401 26.9814 436.875 26.765 437.258 26.332C437.641 25.8945 437.832 25.2109 437.832 24.2812C437.832 23.3926 437.634 22.7227 437.237 22.2715C436.845 21.8203 436.371 21.5947 435.815 21.5947C435.269 21.5947 434.804 21.818 434.421 22.2646C434.038 22.7067 433.847 23.3652 433.847 24.2402ZM440.854 19.3936V17.9785H442.084V19.3936H440.854ZM440.854 28V20.7402H442.084V28H440.854ZM443.964 28V20.7402H445.071V21.7725C445.604 20.9749 446.375 20.5762 447.382 20.5762C447.819 20.5762 448.22 20.6559 448.585 20.8154C448.954 20.9704 449.23 21.1755 449.412 21.4307C449.594 21.6859 449.722 21.9889 449.795 22.3398C449.84 22.5677 449.863 22.9665 449.863 23.5361V28H448.633V23.584C448.633 23.0827 448.585 22.709 448.489 22.4629C448.394 22.2122 448.223 22.014 447.977 21.8682C447.735 21.7178 447.45 21.6426 447.122 21.6426C446.598 21.6426 446.145 21.8089 445.762 22.1416C445.383 22.4743 445.194 23.1055 445.194 24.0352V28H443.964ZM456.727 25.6621L457.998 25.8193C457.798 26.5622 457.426 27.1387 456.884 27.5488C456.341 27.959 455.649 28.1641 454.806 28.1641C453.744 28.1641 452.901 27.8382 452.276 27.1865C451.657 26.5303 451.347 25.612 451.347 24.4316C451.347 23.2103 451.661 22.2624 452.29 21.5879C452.919 20.9134 453.735 20.5762 454.737 20.5762C455.708 20.5762 456.501 20.9066 457.116 21.5674C457.731 22.2282 458.039 23.1579 458.039 24.3564C458.039 24.4294 458.037 24.5387 458.032 24.6846H452.618C452.664 25.4821 452.889 26.0928 453.295 26.5166C453.701 26.9404 454.206 27.1523 454.812 27.1523C455.264 27.1523 455.649 27.0339 455.968 26.7969C456.287 26.5599 456.54 26.1816 456.727 25.6621ZM452.687 23.6729H456.74C456.686 23.0622 456.531 22.6042 456.275 22.2988C455.883 21.8249 455.375 21.5879 454.751 21.5879C454.186 21.5879 453.71 21.777 453.322 22.1553C452.939 22.5335 452.728 23.0394 452.687 23.6729ZM464.52 25.6621L465.791 25.8193C465.59 26.5622 465.219 27.1387 464.677 27.5488C464.134 27.959 463.442 28.1641 462.599 28.1641C461.537 28.1641 460.694 27.8382 460.069 27.1865C459.45 26.5303 459.14 25.612 459.14 24.4316C459.14 23.2103 459.454 22.2624 460.083 21.5879C460.712 20.9134 461.528 20.5762 462.53 20.5762C463.501 20.5762 464.294 20.9066 464.909 21.5674C465.524 22.2282 465.832 23.1579 465.832 24.3564C465.832 24.4294 465.83 24.5387 465.825 24.6846H460.411C460.457 25.4821 460.682 26.0928 461.088 26.5166C461.493 26.9404 461.999 27.1523 462.605 27.1523C463.057 27.1523 463.442 27.0339 463.761 26.7969C464.08 26.5599 464.333 26.1816 464.52 25.6621ZM460.479 23.6729H464.533C464.479 23.0622 464.324 22.6042 464.068 22.2988C463.676 21.8249 463.168 21.5879 462.544 21.5879C461.979 21.5879 461.503 21.777 461.115 22.1553C460.732 22.5335 460.521 23.0394 460.479 23.6729ZM467.329 28V20.7402H468.437V21.8408C468.719 21.3258 468.979 20.9863 469.216 20.8223C469.457 20.6582 469.722 20.5762 470.009 20.5762C470.424 20.5762 470.845 20.7083 471.273 20.9727L470.85 22.1143C470.549 21.9365 470.248 21.8477 469.947 21.8477C469.678 21.8477 469.437 21.9297 469.223 22.0938C469.008 22.2533 468.856 22.4766 468.765 22.7637C468.628 23.2012 468.56 23.6797 468.56 24.1992V28H467.329ZM472.012 19.3936V17.9785H473.242V19.3936H472.012ZM472.012 28V20.7402H473.242V28H472.012ZM475.122 28V20.7402H476.229V21.7725C476.763 20.9749 477.533 20.5762 478.54 20.5762C478.978 20.5762 479.379 20.6559 479.743 20.8154C480.112 20.9704 480.388 21.1755 480.57 21.4307C480.753 21.6859 480.88 21.9889 480.953 22.3398C480.999 22.5677 481.021 22.9665 481.021 23.5361V28H479.791V23.584C479.791 23.0827 479.743 22.709 479.647 22.4629C479.552 22.2122 479.381 22.014 479.135 21.8682C478.893 21.7178 478.608 21.6426 478.28 21.6426C477.756 21.6426 477.303 21.8089 476.92 22.1416C476.542 22.4743 476.353 23.1055 476.353 24.0352V28H475.122ZM482.689 28.6016L483.886 28.7793C483.936 29.1484 484.075 29.4173 484.303 29.5859C484.608 29.8138 485.025 29.9277 485.554 29.9277C486.123 29.9277 486.563 29.8138 486.873 29.5859C487.183 29.3581 487.393 29.0391 487.502 28.6289C487.566 28.3783 487.595 27.8519 487.591 27.0498C487.053 27.6833 486.383 28 485.581 28C484.583 28 483.811 27.64 483.264 26.9199C482.717 26.1999 482.443 25.3363 482.443 24.3291C482.443 23.6364 482.569 22.9984 482.819 22.415C483.07 21.8271 483.432 21.3737 483.906 21.0547C484.385 20.7357 484.945 20.5762 485.588 20.5762C486.445 20.5762 487.151 20.9225 487.707 21.6152V20.7402H488.842V27.0156C488.842 28.1458 488.726 28.9456 488.493 29.415C488.265 29.889 487.901 30.2627 487.399 30.5361C486.903 30.8096 486.29 30.9463 485.561 30.9463C484.695 30.9463 483.995 30.7503 483.462 30.3584C482.929 29.971 482.671 29.3854 482.689 28.6016ZM483.708 24.2402C483.708 25.1927 483.897 25.8877 484.275 26.3252C484.654 26.7627 485.128 26.9814 485.697 26.9814C486.262 26.9814 486.736 26.765 487.119 26.332C487.502 25.8945 487.693 25.2109 487.693 24.2812C487.693 23.3926 487.495 22.7227 487.099 22.2715C486.707 21.8203 486.233 21.5947 485.677 21.5947C485.13 21.5947 484.665 21.818 484.282 22.2646C483.899 22.7067 483.708 23.3652 483.708 24.2402Z" fill="black" />
                                <path d="M553.979 28L557.828 17.9785H559.257L563.358 28H561.848L560.679 24.9648H556.488L555.388 28H553.979ZM556.871 23.8848H560.269L559.223 21.1094C558.904 20.2663 558.667 19.5736 558.512 19.0312C558.384 19.6738 558.204 20.3118 557.972 20.9453L556.871 23.8848ZM568.971 28V27.084C568.51 27.804 567.834 28.1641 566.94 28.1641C566.362 28.1641 565.828 28.0046 565.341 27.6855C564.858 27.3665 564.482 26.9222 564.213 26.3525C563.949 25.7783 563.816 25.1198 563.816 24.377C563.816 23.6523 563.937 22.9961 564.179 22.4082C564.42 21.8158 564.783 21.3623 565.266 21.0479C565.749 20.7334 566.289 20.5762 566.886 20.5762C567.323 20.5762 567.713 20.6696 568.055 20.8564C568.396 21.0387 568.674 21.278 568.889 21.5742V17.9785H570.112V28H568.971ZM565.081 24.377C565.081 25.3066 565.277 26.0016 565.669 26.4619C566.061 26.9222 566.523 27.1523 567.057 27.1523C567.594 27.1523 568.05 26.9336 568.424 26.4961C568.802 26.054 568.991 25.3818 568.991 24.4795C568.991 23.486 568.8 22.7568 568.417 22.292C568.034 21.8271 567.562 21.5947 567.002 21.5947C566.455 21.5947 565.997 21.818 565.628 22.2646C565.263 22.7113 565.081 23.4154 565.081 24.377ZM572.054 28V20.7402H573.154V21.7588C573.382 21.4033 573.685 21.1185 574.063 20.9043C574.442 20.6855 574.872 20.5762 575.355 20.5762C575.893 20.5762 576.333 20.6878 576.675 20.9111C577.021 21.1344 577.265 21.4466 577.406 21.8477C577.98 21 578.728 20.5762 579.648 20.5762C580.368 20.5762 580.922 20.7767 581.31 21.1777C581.697 21.5742 581.891 22.1872 581.891 23.0166V28H580.667V23.4268C580.667 22.9346 580.626 22.5814 580.544 22.3672C580.466 22.1484 580.323 21.973 580.113 21.8408C579.904 21.7087 579.658 21.6426 579.375 21.6426C578.865 21.6426 578.441 21.8135 578.104 22.1553C577.766 22.4925 577.598 23.0348 577.598 23.7822V28H576.367V23.2832C576.367 22.7363 576.267 22.3262 576.066 22.0527C575.866 21.7793 575.538 21.6426 575.082 21.6426C574.736 21.6426 574.414 21.7337 574.118 21.916C573.826 22.0983 573.615 22.3649 573.482 22.7158C573.35 23.0667 573.284 23.5726 573.284 24.2334V28H572.054ZM583.723 19.3936V17.9785H584.953V19.3936H583.723ZM583.723 28V20.7402H584.953V28H583.723ZM586.833 28V20.7402H587.94V21.7725C588.474 20.9749 589.244 20.5762 590.251 20.5762C590.688 20.5762 591.09 20.6559 591.454 20.8154C591.823 20.9704 592.099 21.1755 592.281 21.4307C592.464 21.6859 592.591 21.9889 592.664 22.3398C592.71 22.5677 592.732 22.9665 592.732 23.5361V28H591.502V23.584C591.502 23.0827 591.454 22.709 591.358 22.4629C591.263 22.2122 591.092 22.014 590.846 21.8682C590.604 21.7178 590.319 21.6426 589.991 21.6426C589.467 21.6426 589.014 21.8089 588.631 22.1416C588.253 22.4743 588.063 23.1055 588.063 24.0352V28H586.833ZM594.633 19.3936V17.9785H595.863V19.3936H594.633ZM594.633 28V20.7402H595.863V28H594.633ZM597.251 25.833L598.468 25.6416C598.536 26.1292 598.725 26.5029 599.035 26.7627C599.35 27.0225 599.787 27.1523 600.348 27.1523C600.913 27.1523 601.332 27.0384 601.605 26.8105C601.879 26.5781 602.016 26.307 602.016 25.9971C602.016 25.7191 601.895 25.5003 601.653 25.3408C601.485 25.2314 601.065 25.0924 600.396 24.9238C599.493 24.696 598.867 24.5 598.516 24.3359C598.169 24.1673 597.905 23.9372 597.723 23.6455C597.545 23.3493 597.456 23.0234 597.456 22.668C597.456 22.3444 597.529 22.0459 597.675 21.7725C597.825 21.4945 598.028 21.2643 598.283 21.082C598.475 20.9408 598.734 20.8223 599.062 20.7266C599.395 20.6263 599.751 20.5762 600.129 20.5762C600.699 20.5762 601.198 20.6582 601.626 20.8223C602.059 20.9863 602.378 21.2096 602.583 21.4922C602.788 21.7702 602.929 22.1439 603.007 22.6133L601.804 22.7773C601.749 22.4036 601.59 22.112 601.325 21.9023C601.065 21.6927 600.696 21.5879 600.218 21.5879C599.653 21.5879 599.249 21.6813 599.008 21.8682C598.766 22.055 598.646 22.2738 598.646 22.5244C598.646 22.6839 598.696 22.8275 598.796 22.9551C598.896 23.0872 599.053 23.1966 599.268 23.2832C599.391 23.3288 599.753 23.4336 600.354 23.5977C601.225 23.8301 601.831 24.0215 602.173 24.1719C602.519 24.3177 602.79 24.5319 602.986 24.8145C603.182 25.097 603.28 25.4479 603.28 25.8672C603.28 26.2773 603.16 26.6647 602.918 27.0293C602.681 27.3893 602.337 27.6696 601.886 27.8701C601.435 28.0661 600.924 28.1641 600.354 28.1641C599.411 28.1641 598.691 27.9681 598.194 27.5762C597.702 27.1842 597.388 26.6032 597.251 25.833ZM607.43 26.8994L607.607 27.9863C607.261 28.0592 606.951 28.0957 606.678 28.0957C606.231 28.0957 605.885 28.0251 605.639 27.8838C605.393 27.7425 605.219 27.5579 605.119 27.3301C605.019 27.0977 604.969 26.6123 604.969 25.874V21.6973H604.066V20.7402H604.969V18.9424L606.192 18.2041V20.7402H607.43V21.6973H606.192V25.9424C606.192 26.2933 606.213 26.5189 606.254 26.6191C606.299 26.7194 606.37 26.7992 606.466 26.8584C606.566 26.9176 606.707 26.9473 606.89 26.9473C607.026 26.9473 607.206 26.9313 607.43 26.8994ZM608.626 28V20.7402H609.733V21.8408C610.016 21.3258 610.276 20.9863 610.513 20.8223C610.754 20.6582 611.019 20.5762 611.306 20.5762C611.72 20.5762 612.142 20.7083 612.57 20.9727L612.146 22.1143C611.846 21.9365 611.545 21.8477 611.244 21.8477C610.975 21.8477 610.734 21.9297 610.52 22.0938C610.305 22.2533 610.153 22.4766 610.062 22.7637C609.925 23.2012 609.856 23.6797 609.856 24.1992V28H608.626ZM618.039 27.1045C617.583 27.4919 617.144 27.7653 616.72 27.9248C616.3 28.0843 615.849 28.1641 615.366 28.1641C614.569 28.1641 613.956 27.9704 613.527 27.583C613.099 27.1911 612.885 26.6921 612.885 26.0859C612.885 25.7305 612.965 25.4069 613.124 25.1152C613.288 24.819 613.5 24.582 613.76 24.4043C614.024 24.2266 614.32 24.0921 614.648 24.001C614.89 23.9372 615.255 23.8757 615.742 23.8164C616.736 23.6979 617.467 23.5566 617.937 23.3926C617.941 23.224 617.943 23.1169 617.943 23.0713C617.943 22.57 617.827 22.2168 617.595 22.0117C617.28 21.7337 616.813 21.5947 616.193 21.5947C615.615 21.5947 615.186 21.6973 614.908 21.9023C614.635 22.1029 614.432 22.4606 614.3 22.9756L613.097 22.8115C613.206 22.2965 613.386 21.8818 613.637 21.5674C613.887 21.2484 614.25 21.0046 614.724 20.8359C615.198 20.6628 615.747 20.5762 616.371 20.5762C616.991 20.5762 617.494 20.6491 617.882 20.7949C618.269 20.9408 618.554 21.1253 618.736 21.3486C618.919 21.5674 619.046 21.8454 619.119 22.1826C619.16 22.3923 619.181 22.7705 619.181 23.3174V24.958C619.181 26.1019 619.206 26.8265 619.256 27.1318C619.311 27.4326 619.415 27.722 619.57 28H618.285C618.158 27.7448 618.076 27.4463 618.039 27.1045ZM617.937 24.3564C617.49 24.5387 616.82 24.6937 615.927 24.8213C615.421 24.8942 615.063 24.9762 614.854 25.0674C614.644 25.1585 614.482 25.293 614.368 25.4707C614.254 25.6439 614.197 25.8376 614.197 26.0518C614.197 26.3799 614.32 26.6533 614.566 26.8721C614.817 27.0908 615.182 27.2002 615.66 27.2002C616.134 27.2002 616.556 27.0977 616.925 26.8926C617.294 26.6829 617.565 26.3981 617.738 26.0381C617.87 25.7601 617.937 25.3499 617.937 24.8076V24.3564ZM623.781 26.8994L623.959 27.9863C623.613 28.0592 623.303 28.0957 623.029 28.0957C622.583 28.0957 622.236 28.0251 621.99 27.8838C621.744 27.7425 621.571 27.5579 621.471 27.3301C621.37 27.0977 621.32 26.6123 621.32 25.874V21.6973H620.418V20.7402H621.32V18.9424L622.544 18.2041V20.7402H623.781V21.6973H622.544V25.9424C622.544 26.2933 622.564 26.5189 622.605 26.6191C622.651 26.7194 622.722 26.7992 622.817 26.8584C622.918 26.9176 623.059 26.9473 623.241 26.9473C623.378 26.9473 623.558 26.9313 623.781 26.8994ZM624.998 19.3936V17.9785H626.229V19.3936H624.998ZM624.998 28V20.7402H626.229V28H624.998ZM630.125 28L627.363 20.7402H628.662L630.221 25.0879C630.389 25.5573 630.544 26.0449 630.686 26.5508C630.795 26.168 630.948 25.7077 631.144 25.1699L632.757 20.7402H634.021L631.273 28H630.125ZM640.078 25.6621L641.35 25.8193C641.149 26.5622 640.778 27.1387 640.235 27.5488C639.693 27.959 639 28.1641 638.157 28.1641C637.095 28.1641 636.252 27.8382 635.628 27.1865C635.008 26.5303 634.698 25.612 634.698 24.4316C634.698 23.2103 635.013 22.2624 635.642 21.5879C636.271 20.9134 637.086 20.5762 638.089 20.5762C639.06 20.5762 639.853 20.9066 640.468 21.5674C641.083 22.2282 641.391 23.1579 641.391 24.3564C641.391 24.4294 641.388 24.5387 641.384 24.6846H635.97C636.015 25.4821 636.241 26.0928 636.646 26.5166C637.052 26.9404 637.558 27.1523 638.164 27.1523C638.615 27.1523 639 27.0339 639.319 26.7969C639.638 26.5599 639.891 26.1816 640.078 25.6621ZM636.038 23.6729H640.092C640.037 23.0622 639.882 22.6042 639.627 22.2988C639.235 21.8249 638.727 21.5879 638.103 21.5879C637.537 21.5879 637.061 21.777 636.674 22.1553C636.291 22.5335 636.079 23.0394 636.038 23.6729Z" fill="black" />
                                <path d="M714.08 28V17.9785H717.86C718.526 17.9785 719.034 18.0104 719.385 18.0742C719.877 18.1562 720.289 18.3135 720.622 18.5459C720.955 18.7738 721.221 19.0951 721.422 19.5098C721.627 19.9245 721.729 20.3802 721.729 20.877C721.729 21.7292 721.458 22.4515 720.916 23.0439C720.374 23.6318 719.394 23.9258 717.977 23.9258H715.406V28H714.08ZM715.406 22.7432H717.997C718.854 22.7432 719.462 22.5837 719.822 22.2646C720.182 21.9456 720.362 21.4967 720.362 20.918C720.362 20.4987 720.255 20.141 720.041 19.8447C719.831 19.5439 719.553 19.3457 719.207 19.25C718.984 19.1908 718.571 19.1611 717.97 19.1611H715.406V22.7432ZM723.418 28V17.9785H727.198C727.864 17.9785 728.372 18.0104 728.723 18.0742C729.215 18.1562 729.627 18.3135 729.96 18.5459C730.293 18.7738 730.559 19.0951 730.76 19.5098C730.965 19.9245 731.067 20.3802 731.067 20.877C731.067 21.7292 730.796 22.4515 730.254 23.0439C729.712 23.6318 728.732 23.9258 727.314 23.9258H724.744V28H723.418ZM724.744 22.7432H727.335C728.192 22.7432 728.8 22.5837 729.16 22.2646C729.52 21.9456 729.7 21.4967 729.7 20.918C729.7 20.4987 729.593 20.141 729.379 19.8447C729.169 19.5439 728.891 19.3457 728.545 19.25C728.322 19.1908 727.909 19.1611 727.308 19.1611H724.744V22.7432ZM732.783 28V17.9785H740.029V19.1611H734.109V22.2305H739.653V23.4062H734.109V26.8174H740.262V28H732.783Z" fill="white" />
                              </svg>
                            </div>
                            <div className="text-right">
                              <p className="font-weight-bold m-0 mx-3">Lowest Level of Control</p>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    {this.state.selectedCheckSwms &&
                      this.state.selectedCheckSwms.length > 0 &&
                      <div className="container-fluid">
                        <div className="row mb-0">
                          <div className="col-sm-12">
                            <div className="content-box">
                              <div className="form-group mb-0">
                                <label className="half-width"> Swms</label>
                              </div>
                            </div>
                          </div>
                        </div>


                        <table className="table mytable4 table-bordered border-0 fixed-layout">
                          <thead className="thead-dark">
                            <tr>
                              <th>Job Activity</th>
                              <th>Potential Safety and Enviromental Hazards</th>
                              <th>Consequences</th>
                              <th className="p-0" width={150}>
                                <table className="table remove-border m-0">
                                  <tbody>
                                    <tr>
                                      <th colSpan={3}>Risk Rating</th>
                                    </tr>
                                    <tr>
                                      <th width={27}>L</th>
                                      <th width={27}>C</th>
                                      <th width={27}>R</th>
                                    </tr>
                                  </tbody>
                                </table>
                              </th>
                              <th width="450">Control Measures</th>
                              <th className="p-0" width={150}>
                                <table className="table remove-border m-0">
                                  <tbody>
                                    <tr>
                                      <th colSpan={3}>Risk Rating</th>
                                    </tr>
                                    <tr>
                                      <th width={27}>L</th>
                                      <th width={27}>C</th>
                                      <th width={27}>R</th>
                                    </tr>
                                  </tbody>
                                </table>
                              </th>
                              <th>Responsible Person</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.selectedCheckSwms &&
                              this.state.selectedCheckSwms.length > 0 &&
                              this.state.selectedCheckSwms.map((val) => {
                                return (
                                  <tr>
                                    <td width={153}>{val.activity}</td>
                                    <td width={153}>
                                      <ul className="list-4">
                                        {val.hazard.length > 0 && val.hazard.map((val) => {
                                          return <li>{val.hazard_title}</li>

                                        })}
                                      </ul>
                                    </td>
                                    <td width={153}>
                                      <ul className="list-4">
                                        {val.consequence.length > 0 && val.consequence.map((val) => {
                                          return <li>{val.consequences_title}</li>

                                        })}
                                      </ul>
                                    </td>
                                    <td className="p-0 border-0" width="150">
                                      <div className="parent-fix">
                                        <div className="fix-1">
                                          L{val.likelihood_before_controls && val.likelihood_before_controls}
                                        </div>
                                        <div className="fix-1">
                                          C{val.consequence_before_controls && val.consequence_before_controls}
                                        </div>
                                        <div className="fix-1">
                                          {val.risk_rating_before_controls && val.risk_rating_before_controls}
                                        </div>
                                      </div>
                                    </td>
                                    <td width={450}>
                                      <div className="list-style-custom"
                                        dangerouslySetInnerHTML={{
                                          __html: val.control_measures,
                                        }}
                                      />
                                    </td>
                                    <td className="p-0 border-0" width="150">
                                      <div className="parent-fix">
                                        <div className="fix-1">
                                          L{val.likelihood_after_controls && val.likelihood_after_controls}
                                        </div>
                                        <div className="fix-1">
                                          C{val.consequence_after_controls && val.consequence_after_controls}
                                        </div>
                                        <div className="fix-1">
                                          {val.risk_rating_after_controls && val.risk_rating_after_controls}
                                        </div>
                                      </div>
                                    </td>
                                    <td width={122}>
                                      <ul className="list-4">
                                        {val.person_responsible.length > 0 && val.person_responsible.map((person) =>
                                        (
                                          person.person_responsible_label ? <li>{person.person_responsible_label}</li> : ''

                                        ))}
                                      </ul>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    }

                    {this.state.selectedCheckSpecific && this.state.selectedCheckSpecific.length > 0 &&
                      <div className="container-fluid">
                        <div className="row mb-0">
                          <div className="col-sm-12">
                            <div className="content-box">
                              <div className="form-group mb-0">
                                <label className="half-width"> Site Specific Job Safety Analysis</label>

                              </div>
                            </div>
                          </div>
                        </div>


                        <table className="table mytable4 table-bordered border-0 fixed-layout">
                          <thead className="thead-dark">
                            <tr>
                              <th>Job Activity</th>
                              <th>Potential Safety and Enviromental Hazards</th>
                              <th>Consequences</th>
                              <th className="p-0" width={150}>
                                <table className="table remove-border m-0">
                                  <tbody>
                                    <tr>
                                      <th colSpan={3}>Risk Rating</th>
                                    </tr>
                                    <tr>
                                      <th width={27}>L</th>
                                      <th width={27}>C</th>
                                      <th width={27}>R</th>
                                    </tr>
                                  </tbody>
                                </table>
                              </th>
                              <th width="450">Control Measures</th>
                              <th className="p-0" width={150}>
                                <table className="table remove-border m-0">
                                  <tbody>
                                    <tr>
                                      <th colSpan={3}>Risk Rating</th>
                                    </tr>
                                    <tr>
                                      <th width={27}>L</th>
                                      <th width={27}>C</th>
                                      <th width={27}>R</th>
                                    </tr>
                                  </tbody>
                                </table>
                              </th>
                              <th>Responsible Person</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.selectedCheckSpecific &&
                              this.state.selectedCheckSpecific.length > 0 &&
                              this.state.selectedCheckSpecific.map((val) => {
                                return (
                                  <tr>
                                    <td width={153}>{val.activity}</td>
                                    <td width={153}>
                                      <ul className="list-4">
                                        {val.hazards.length > 0 && val.hazards.map((val) => {
                                          return <li>{val.site_specific_swms_hazards}</li>

                                        })}

                                      </ul>
                                    </td>
                                    <td width={153}>
                                      <ul className="list-4">
                                        {val.consequences.length > 0 && val.consequences.map((val) => {
                                          return <li>{val.site_specific_swms_consequences}</li>

                                        })}

                                      </ul>
                                    </td>
                                    <td className="p-0 border-0" width="150">
                                      <div className="parent-fix">
                                        <div className="fix-1">
                                          L{val.likelihood_before_controls && val.likelihood_before_controls}
                                        </div>
                                        <div className="fix-1">
                                          C{val.consequence_before_controls && val.consequence_before_controls}
                                        </div>
                                        <div className="fix-1">
                                          {val.risk_rating_before_controls && val.risk_rating_before_controls}
                                        </div>
                                      </div>
                                    </td>
                                    <td width={450}>
                                      <div className="list-style-custom"
                                        dangerouslySetInnerHTML={{
                                          __html: val.control_measures,
                                        }}
                                      />
                                    </td>
                                    <td className="p-0 border-0" width="150">
                                      <div className="parent-fix">
                                        <div className="fix-1">
                                          L{val.likelihood_after_controls && val.likelihood_after_controls}
                                        </div>
                                        <div className="fix-1">
                                          C{val.consequence_after_controls && val.consequence_after_controls}
                                        </div>
                                        <div className="fix-1">
                                          {val.risk_rating_after_controls && val.risk_rating_after_controls}
                                        </div>
                                      </div>
                                    </td>
                                    <td width={122}>
                                      <ul className="list-4">
                                        {val.person_responsibles.length > 0 && val.person_responsibles.map((person) =>
                                          person.person_responsible_label ?
                                            <li>{person.person_responsible_label}</li> : ''
                                        )}
                                      </ul>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    }

                    {this.state.selectedJob_swms_sign_offs &&
                      this.state.selectedJob_swms_sign_offs.length > 0 &&
                      <div className="container-fluid nitin">
                        <div className="row mb-0">
                          <div className="col-sm-12">
                            <div className="content-box">
                              <div className="form-group">
                                <label className="text-left">SWMS Sign Off</label>
                                <textarea
                                  className="form-control previewswms-textarea"
                                  rows={2}
                                  readOnly
                                  defaultValue={
                                    "We the undersigned, confirm that the SWMS nominated above has been explained and its contents are clearly understood and accepted. We also confirm that our required qualifications to undertake this activity are current. We also clearly understand the controls in this SWMS must be applied as documented; otherwise work is to cease immediately."
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {this.state.selectedJob_swms_sign_offs &&
                          this.state.selectedJob_swms_sign_offs.length > 0 ? (
                          this.state.selectedJob_swms_sign_offs.map((val) => {
                            return (
                              <div className="row border-all mb-2">
                                <div className="col-sm-8">
                                  <div className="row">
                                    <div className="col-sm-6">
                                      <div className="form-group flexlabel mb-0">
                                        <label className="leftalign">Worker Name:</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name
                                          defaultValue={
                                            val.user_first_name + " " + val.user_last_name
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group flexlabel mb-0">
                                        <label className="leftalign">
                                          Emergency Contact:
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name
                                          defaultValue={val.ec_full_name}
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group flexlabel mb-0">
                                        <label className="leftalign">Worker Role:</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name
                                          defaultValue={val.user_role_name}
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group flexlabel mb-0">
                                        <label className="leftalign">Relationship:</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name
                                          defaultValue={val.relationship}
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group flexlabel mb-0">
                                        <label className="leftalign">Mobile:</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name
                                          defaultValue={val.ec_mobile_number}
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group flexlabel mb-0">
                                        <label className="leftalign">Mobile:</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name
                                          defaultValue={val.phone_number}
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-4">
                                  <div className="row">
                                    <div className="col-sm-6">
                                      <div className="form-group mb-0">
                                        <label className="signs">Signature: </label>
                                        {val.sign ?
                                          <div className="swms-sign-image-holder">
                                            <img
                                              src={val.sign}
                                              alt="sign"
                                              className="swms-sign-image"
                                            />
                                          </div> : ""}
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group mb-0">
                                        <label className="signs">Date:</label>
                                        <input
                                          type="text"
                                          className="form-control hfull"
                                          name
                                          defaultValue={moment(val.sign_date).format("DD/MM/YYYY")}
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-sm-12">
                                  <div className="form-group mb-0">
                                    <label className="licence">
                                      Licence Type &amp; Number:
                                    </label>
                                    <div className="row align-items-start">
                                      {val.licenses &&
                                        val.licenses.length > 0 &&
                                        val.licenses.map((license) => {
                                          return (
                                            <div className="col-3" key={license.id}>
                                              <p className="m-0"><span className="mr-1" style={{ fontSize: '12px' }}>&#x25cf;</span>{license.license_type_and_number}{" "}</p>
                                            </div>
                                          );
                                        })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          })
                        ) : ''}
                      </div>
                    }

                    <footer className="container-fluid footbg swmsPreview-footer">
                      {this.state.selectedDocument_details && (
                        <div className="row mb-0">
                          <div className="col-sm-3">
                            <div className="form-group flexlabel">
                              <label>Document Number:</label>
                              <input
                                type="text"
                                className="form-control"
                                name
                                defaultValue={this.state.selectedDocument_details && this.state.selectedDocument_details.doc_number ? this.state.selectedDocument_details.doc_number : ''}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group flexlabel">
                              <label>Issue Date:</label>
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={this.state.selectedDocument_details && this.state.selectedDocument_details.doc_issue_date ?
                                  this.state.selectedDocument_details.doc_issue_date : ''}
                                name
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group flexlabel">
                              <label>Revision Date:</label>
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={this.state.selectedDocument_details && this.state.selectedDocument_details ?
                                  this.state.selectedDocument_details.doc_revision_date : ''}
                                name
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group flexlabel">
                              <label>Revision No:</label>
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={this.state.selectedDocument_details && this.state.selectedDocument_details.doc_revision_number ?
                                  this.state.selectedDocument_details.doc_revision_number : ''}
                                name
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="row my-4">
                        <div className="col-4">
                          <div className="text-center">
                            <div className="d-flex align-items-center">
                              <p className="m-0 mr-2">SWMS Generated By:</p>
                              <img src={footerLogo} style={{ maxHeight: '25px' }} />
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <p className="text-center">Safe Work Method Statement</p>
                        </div>
                        <div className="col-4">
                          <p className="text-right">Page 1</p>
                        </div>
                      </div>
                    </footer>
                  </div>
                </div>
                <div className="py-4 px-4 text-right" style={{ backgroundColor: '#fff' }}>
                  <Button
                    className={`${jobStyles.PrimaryButton} mx-2`}
                    disabled={!this.state.swmsPdfLink}
                    onClick={() => this.downloadFile(this.state.swmsPdfLink)}
                  >
                    <DownloadOutlined style={{ fontSize: '15px' }} />
                    Download SWMS
                  </Button>
                  <button
                    type="button"
                    disabled={!this.state.swmsPdfLink}
                    className={jobStyles.PrimaryButton}
                    onClick={() => this.props.onSendEmail()}>
                    <span>Email to client</span>
                  </button>
                </div>
              </>
              :
              <div className="container-fluid bg-white p-5">
                <div className="row align-items-center">
                  <div className="col-12 text-center">
                    <h5 className="text-danger">There was an error while loading SWMS Preview.</h5>
                  </div>
                </div>
              </div>
            }
          </>
        }
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(SWMSMastersActions, dispatch),
  };
};

export default compose(
  connect(null, mapDispatchToProps),
  reduxForm({
    form: "SwmsPreviewJobSwms",
    enableReinitialize: true,
  })
)(SwmsPreviewJobSwms);
